import { useNavigate } from "react-router-dom";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";

const OrgItem = (props: any) => {
  const { setSelectedorg } = useStateSetter();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        setSelectedorg(props.item);
        navigate(`/home/${props.item.id}/modules`);
      }}
      className="bg-white shadow rounded-[10px] w-[160px] h-[150px] border border-customGray p-3 flex flex-col justify-center items-center"
    >
      {/* <img
        crossOrigin="anonymous"
        className="rounded-full border shadow border-customGray text-textbg "
        src={props.item.logo}
        alt="Logo"
      /> */}

      <p className="p-2 cursor-pointer w-[90px] h-[90px] rounded-full border text-[50px] text-center shadow font-bold  border-customGray text-textbg ">
        {props.item.orgName.charAt(0)}
      </p>
      <p className="font-bold text-sm text-textbg mt-1 cursor-pointer ">
        {props.item.orgName}{" "}
      </p>
    </div>
  );
};

export { OrgItem };
